// export const SYSTEMS = '../_data/safer_clean.csv';
export const SYSTEMS_URL = new URL('../_data/systems.csv', import.meta.url);
export const MONITORING_RESULTS_URL = new URL(
  '../_data/monitoring_results.csv',
  import.meta.url
);
export const NOTICES_URL = new URL('../_data/notices.csv', import.meta.url);
export const GEOGRAPHY_URL = new URL('../_data/ca_proj.json', import.meta.url);
export const VIOLATIONS = new URL(
  '../_data/violations_grouped.csv',
  import.meta.url
);
